import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useGlobal } from '@rcg/ui-react';
import useDictionary from '../../../hooks/useDictionary';
import Dictionary from '../../../utils/dictionary';
import { isFlexibilityService } from '../../../utils/inflightServices';

const useStyles = makeStyles((Theme) => ({
  section: {
    marginBottom: '16px',
  },
  title: {
    fontFamily: Theme.typography.base.bold,
    fontSize: Theme.typography.size[0],
    fontWeight: 700,
    lineHeight: '16px',
    color: '#083870',
    margin: '0 0 6px 0',
  },
  list: {
    margin: 0,
    paddingLeft: '16px',
    '& > li': {
      flex: '1 0 0',
      alignSelf: 'stretch',
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[0],
      fontWeight: 400,
      lineHeight: '16px',
      color: '#083870',
      marginBottom: '2px',
      [Theme.breakpoints.up('md')]: {
        lineHeight: '20px',
        marginBottom: '4px',
      },
    },
  },
}));

const FlexibilitySection = ({ inflightServices = [] }) => {
  const classes = useStyles();
  const getDictionary = useDictionary(Dictionary);
  const { renderContent } = useGlobal();

  const flexItems = inflightServices.filter(isFlexibilityService);

  if (flexItems.length === 0) return null;

  return (
    <div className={classes.section}>
      <p className={classes.title}>{getDictionary(Dictionary.airFareFlexibilityTitle.key)}</p>
      <ul className={classes.list}>
        {flexItems.map((s) => (
          <li key={s.key}>{renderContent(s.key, s.value)}</li>
        ))}
      </ul>
    </div>
  );
};

export default FlexibilitySection;
